export default class {
  constructor(element, step) {
    this.element = element;
    this.step = step;
    this.$btnSkip = this.element.querySelector('button.btn.skip-discount-package');
    this.$btnSave = this.element.querySelector('button.btn.save-discount-package');
    this.$actionButtons = this.element.querySelector('.discount-action-buttons');
    this.$cards = this.element.querySelectorAll('.discount-packages .discount-package-card');
    this._onContinue = this._onUpdate = () => {};
    this._beforeSelect = () => { return new Promise((resolve, _) => { return resolve() }) };
    this._onSkipButton = () => { return new Promise((resolve, _) => { return resolve() }) };
    this.discountPackage = {
      services: [],
      relationships: [],
      valueCents: 0,
      byService: undefined
    };

    this.bindEvents();
  }

  bindEvents() {
    this.$btnSkip.addEventListener('click', (ev) => this.onSkipDiscount(ev));
    this.$btnSave.addEventListener('click', (ev) => this.onSave(ev));
    this.$actionButtons.classList.toggle('hidden', this.$cards.length == 0);

    this.$cards.forEach(($card) => {
      $card.addEventListener('click', () => {
        if ($card.classList.contains('selected'))
          return;

        this._beforeSelect($card).then(() => this.selectDiscountPackage($card) );
      });
    });
  }

  selectDiscountPackage($card) {
    $(this.$cards).removeClass('selected');
    $card.classList.add('selected');
    $card.querySelector('input[type="radio"]').checked = true;
    this.updateSaveButton();
    this.updateStepSummary();
    this.discountPackage.valueCents = $card.dataset.valueCents;
    this.discountPackage.byService = !!$card.dataset.byActivity;
    this.discountPackage.services = JSON.parse($card.dataset.activities || '[]');
    this.discountPackage.relationships = JSON.parse($card.dataset.relationships || '[]');
    this.discountPackage.id = $card.dataset.id;
    this._onUpdate(this.discountPackage);
  }

  updateSaveButton() {
    let canSave = this.element.querySelectorAll('.discount-packages .discount-package-card input[type="radio"]:checked').length > 0;
    canSave ? this.$btnSave.removeAttribute('disabled') : this.$btnSave.setAttribute('disabled', '');
  }

  updateStepSummary() {
    let rb = this.element.querySelector('.discount-packages input[type="radio"]:checked');

    if (!rb)
      return this.step.updateSummary('<span class="d-block">nenhum pacote selecionado</span>');

    let summary = `<span class="font-high-green">${rb.closest('.header').querySelector('.title h5').innerHTML}</span>`;
    summary += rb.closest('.discount-package-card').querySelector('.body ul.rules').outerHTML;
    this.step.updateSummary(`<span>${summary}</span>`);
  }

  beforeSelect(func) {
    this._beforeSelect = func;
    return this;
  }

  resetDiscountPackage() {
    this.discountPackage.valueCents = 0;
    this.discountPackage.relationships = this.discountPackage.services = [];
    this.discountPackage.id = this.discountPackage.byService = undefined;
  }

  onSave(ev) {
    ev.preventDefault();
    ev.stopPropagation();

    this.step.valid = true;
    this._onContinue(this.discountPackage);
  }

  onSkipDiscount(ev) {
    ev.preventDefault();
    ev.stopPropagation();

    this._onSkipButton().then(() => {
      let rb = this.element.querySelector('.discount-packages input[type="radio"]:checked');

      if (!!rb) {
        rb.checked = false;
        rb.closest('.discount-package-card').classList.remove('selected');
      }

      this.step.valid = true;
      this.updateStepSummary();
      this.resetDiscountPackage();

      this._onUpdate(this.discountPackage);
      this._onContinue(this.discountPackage);
    });
  }

  onSkipButton(func) {
    this._onSkipButton = func;
    return this;
  }

  onUpdate(func) {
    this._onUpdate = func;
    return this;
  }

  onContinue(func) {
    this._onContinue = func;
    return this;
  }
}